import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import LinkedInEmbed from '../../../organisms/LinkedInEmbed';
import ArticleModalTagsSection from './ArticleModalTagsSection';

const ArticleModalLinkedInContent = ({
  article,
  fontSize,
  isOpen,
  onAddTag,
  onRemoveTag
}) => (
  <>
    <LinkedInEmbed article={article} isOpen={isOpen} sx={{ mb: 2 }} />

    {(article.author || article.siteName) && (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
        Por: {article.siteName || article.author || 'Autor não encontrado'}
      </Typography>
    )}

    {article.description && (
      <Box sx={{ my: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
          {article.description}
        </Typography>
      </Box>
    )}

    <ArticleModalTagsSection
      article={article}
      fontSize={fontSize}
      mt={2}
      onAddTag={onAddTag}
      onRemoveTag={onRemoveTag}
    />
  </>
);

ArticleModalLinkedInContent.propTypes = {
  article: PropTypes.shape({
    author: PropTypes.string,
    description: PropTypes.string,
    siteName: PropTypes.string
  }).isRequired,
  fontSize: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onAddTag: PropTypes.func.isRequired,
  onRemoveTag: PropTypes.func
};

ArticleModalLinkedInContent.defaultProps = {
  fontSize: undefined,
  onRemoveTag: null
};

export default ArticleModalLinkedInContent;
